


































































































































import { Component, Vue } from 'vue-property-decorator';
import Certificate from '@/classes/Certificate';
import JobCorpsCenter from '@/classes/JobCorpsCenter';
import StudentProfile from '@/classes/StudentProfile';
import Certification from '@/classes/Certification';
import {dateFormatter} from '@/services/inputTools';

@Component({
    filters: {
        dateFormatter
    }
})
export default class CertificatesReprint extends Vue {
  public currPage: number = 1;
  public perPage: number = 10;

  get currentPage(): number {
      if (this.currPage > this.pages) {
        return this.pages;
      } else {
        return this.currPage;
      }
    }

    set currentPage(num: number) {
      this.currPage = num;
    }

    get pages(): number {
      const val: number = Math.ceil(this.totalRows / this.perPage);
      return val === 0 ? 1 : val;
    }

  public certStartDate: string | null = null;
  public certEndDate: string | null = null;
  public printStartDate: string | null = this.toUTCDateString(new Date());
  public printEndDate: string | null = this.toUTCDateString(new Date());

  public studentDolId: string | null = null;
  public studentLastName: string | null = null;
  public courseName: string | null = null;
  public instructor: string | null = null;

  public show: boolean = false;
  public certIdSelected: number | null = null;
  public certFormSelected: number | null = null;

  public clearFilters() {
    this.printStartDate = this.toUTCDateString(new Date());
    this.printEndDate = this.toUTCDateString(new Date());
    this.certStartDate = null;
    this.certEndDate = null;
    this.studentDolId = null;
    this.studentLastName = null;
    this.courseName = null;
    this.instructor = null;
  }

    get totalRows(): number {
        return (this.filteredCertificates || []).length;
    }

    get fields() {
        return [{
            key: 'dolId',
            label: 'Student ID',
            sortable: true
        }, {
            key: 'studentNameIndex',
            label: 'Name',
            sortable: true
        }, {
            key: 'jobCorpCenterNameIndex',
            label: 'Job Corps Center',
            sortable: true
        }, {
            key: 'studentStatusIndex',
            label: 'Student Status',
            sortable: true
        }, {
            key: 'certificationNameIndex',
            label: 'Course Name',
            sortable: true
        }, {
            key: 'certificationDateAsNumber',
            label: 'Certificate Completion Date',
            sortable: true
        }, {
            key: 'instructorNameIndex',
            label: 'Instructor',
            sortable: true
        }, {
            key: 'printingCompleteAsNumber',
            label: 'Printed',
            sortable: true
        }, {
            key: 'reprint',
            label: 'Reprint'
        }, {
            key: 'details',
            label: 'Details'
        }];
    }

  public getInstructorName(id: number): string {
    const user = this.$store.getters.getUserProfileById(id);
    if (user) {
        return user.getFullName();
    } else {
        return '';
    }
  }

  get filteredCertificates(): Certificate[] {
    let filtered: Certificate[] = this.$store.getters.getCertificates as Certificate[];
    if (undefined !== filtered && filtered.length > 0) {
      if (this.printStartDate !== undefined && this.printStartDate !== null && this.printStartDate.length > 0) {
          const printStartDate: Date = this.toLocalDate(this.printStartDate);
          filtered = filtered.filter((certificate: Certificate) => {
            if (certificate.printingComplete !== undefined && printStartDate) {
              return certificate.printingComplete.getTime() >= printStartDate.getTime();
            } else {
              return true;
            }
          });
      }
      if (this.printEndDate !== undefined && this.printEndDate !== null && this.printEndDate.length > 0) {
          const printEndDate: Date = this.toLocalDate(this.printEndDate);
          printEndDate.setDate(printEndDate.getDate() + 1);
          filtered = filtered.filter((certificate: Certificate) => {
            if (certificate.printingComplete !== undefined && printEndDate !== undefined) {
              return certificate.printingComplete.getTime() < printEndDate.getTime();
            } else {
              return true;
            }
          });
      }
      if (this.certStartDate !== undefined && this.certStartDate !== null && this.certStartDate.length > 0) {
          const certStartDate: Date = new Date(this.certStartDate);
          filtered = filtered.filter((certificate: Certificate) => {
            if (certificate.certificationDate !== undefined && certStartDate) {
              return new Date(certificate.certificationDate).getTime() >= certStartDate.getTime();
            } else {
              return true;
            }
          });
      }
      if (this.certEndDate !== undefined && this.certEndDate !== null && this.certEndDate.length > 0) {
          const certEndDate: Date = new Date(this.certEndDate);
          certEndDate.setDate(certEndDate.getDate() + 1);
          filtered = filtered.filter((certificate: Certificate) => {
            if (certificate.certificationDate !== undefined && certEndDate !== undefined) {
              return new Date(certificate.certificationDate).getTime() < certEndDate.getTime();
            } else {
              return true;
            }
          });
      }
      if (this.studentDolId !== undefined && this.studentDolId !== null && this.studentDolId.length > 0) {
        filtered = filtered.filter((certificate: Certificate) => {
          return this.filteredStudentsByDolId.includes(certificate.studentId as number);
        });
      }
      if (this.studentLastName !== undefined && this.studentLastName !== null && this.studentLastName.length > 0) {
        filtered = filtered.filter((certificate: Certificate) => {
          return this.filteredStudentsByLastName.includes(certificate.studentId as number);
        });
      }
      if (this.instructor !== undefined && this.instructor !== null && this.instructor.length > 0) {
        filtered = filtered.filter((certificate: Certificate) => {
          return this.filteredInstructorsByName.includes(certificate.instructorId as number);
        });
      }
      if (this.courseName !== undefined && this.courseName !== null && this.courseName.length > 0) {
        filtered = filtered.filter((certificate: Certificate) => {
          return this.filteredCourseByName.includes(certificate.certificationId as number);
        });
      }
      return filtered;
    } else {
      return [];
    }
  }

  get filteredStudentsByLastName(): number[] {
    return this.$store.getters['students/getStudentIdsByLastNameString'](this.studentLastName);
  }

  get filteredStudentsByDolId(): number[] {
    return this.$store.getters['students/getStudentIdsByDolIdString'](this.studentDolId);
  }

  get filteredInstructorsByName(): number[] {
    return this.$store.getters.getUserProfileIdsByString(this.instructor);
  }

  get filteredCourseByName(): number[] {
    return this.$store.getters.getCertificationsIdsByName(this.courseName);
  }

  public getJobCorpsCenterName(id: number): string {
    const center: JobCorpsCenter = this.$store.getters.getJobCorpsCenterById(id);
    if (center && center.name !== undefined && center.name !== null) {
      return center.name;
    } else {
      return '';
    }
  }

  public getStudentName(id: number): string {
    const student: StudentProfile = this.$store.getters['students/getStudentById'](id);
    if (student !== undefined) {
      return student.getFullName();
    } else {
      return '';
    }
  }

  public getStudentStatus(id: number): string {
    const student: StudentProfile = this.$store.getters['students/getStudentById'](id);
    if (student !== undefined && student.active !== undefined) {
      return student.active ? 'Active' : 'Inactive';
    } else {
      return '';
    }
  }

  public getCertificationName(id: number): string {
    const certification: Certification = this.$store.getters.getCertificationById(id);
    if (certification && certification.name !== undefined) {
      return certification.name;
    } else {
      return '';
    }
  }

  public printModal(cert: Certificate | null | undefined): void {
    if (cert !== null && cert !== undefined) {
      this.certFormSelected = cert.certificateFormId ? cert.certificateFormId : null;
      this.certIdSelected = cert.id ? cert.id : null;
      this.show = true;
    }
  }

  public closeModal() {
    this.show = false;
    this.certFormSelected = null;
    this.$store.dispatch('loadCertificates', true);
  }

  public printPopup(url: string, id: number | null) {
    if (id !== null) {
      const myPopup = window.open(url + id);
      this.$store.dispatch('loadCertificates', true);
    }
  }

  public toUTCDateString(date: Date): string {
    if (date !== undefined && date !== null) {
        return date.getUTCFullYear() + '-' +
          ('0' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
          ('0' + date.getUTCDate()).slice(-2);
    } else {
      return '';
    }
  }

  public toLocalDate(str: string): Date {
    return new Date(Number(str.substr(0, 4)), (Number(str.substr(5, 2)) - 1), Number(str.substr(8, 2)));
  }

  public getFormLink(cert: Certificate): string {
    return '/forms/certificaterequestform/' + cert.certificateFormId;
  }
}
